import {useEffect, useState} from "react";
import {Avatar, Box, Button, FormControl, Grid, InputLabel, Select, TextField} from "@material-ui/core";
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import {withStyles} from '@material-ui/core/styles';
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import * as React from "react";
import './CashUsersInfo.css';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {CashUsersService} from "../CashUsers/CashUsersService";
import {CashGroupService} from "../CashGroups/CashGroupService";
import {convertToBirthDate, convertToHomeNumber, convertToMobileNumber} from "../../utils/numberConvertor";
import moment from "jalali-moment";
import CashUserChangePassword from "../CashUsers/CashUserChangePassword";
import CashUserChangeUsername from "../CashUsers/CashUserChangeUsername";
import CustomBackButton from "../../component/customButton/CustomBackButton";
import MoreActionButton from "../../component/customButton/MoreActionButton";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";

const CashUsersInfo = ({selectedItemId, openDialog, handleClose, needRefresh}) => {

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new CashUsersService(fundID, token, snackbar, loading)
    const groupService = new CashGroupService(fundID, token, snackbar, loading)

    //Dialog-start
    const styles = (theme) => ({
        root: {
            margin: 0,
            padding: theme.spacing(2),
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    });

    const DialogTitle = withStyles(styles)((props) => {
        const {children, classes, onClose, ...other} = props;
        return (
            <MuiDialogTitle disableTypography className={classes.root} {...other}>
                <Typography variant="h6">{children}</Typography>

            </MuiDialogTitle>
        );
    });

    //Dialog-end
    //set-image-start

    const [imageFile, setImageFile] = useState(null);
    const [imageId, setImageId] = useState(-1);
    const [image, setImage] = useState(null)

    const onImageChange = (event) => {
        if (event.target.files && event.target.files[0]) {
            setImageFile(event.target.files[0]);
            setImageId(-1)
            setImage(URL.createObjectURL(event.target.files[0]));
        }
    }
    // state-start
    const [name, setName] = useState("")
    const [lastName, setLastName] = useState("")
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [isMale, setIsMale] = useState(true)
    const [nationalCode, setNationalCode] = useState("")
    const [personalCode, setPersonalCode] = useState("")
    const [phoneNumber, setPhoneNumber] = useState("")
    const [fixedNumber, setFixedNumber] = useState("")
    const [birthday, setBirthday] = useState("")
    const [education, setEducation] = useState("")
    const [job, setJob] = useState("")
    const [groupSelectedID, setGroupSelectedID] = useState(1)
    const [groupList, setGroupList] = useState([]);
    const [address, setAddress] = useState("")
    const [enabled, setEnabled] = useState(true)
    // state-end

    useEffect(() => {
        if (typeof service !== 'undefined') {
            groupService.getCashGroupsList(
                fundID,
                0,
                "",
                "",
                1000000
            ).then(response => {
                setGroupList([])
                response.data.map((item) => {
                    if (item.enabled)
                        setGroupList(prevState => [...prevState, {
                            name: item.name,
                            id: item.id
                        }])
                })
            }).catch(reason => {
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در دریافت لیست گروه ها"))
            })
        }
    }, [])


    function checkFieldsConditions(isAddNew = true) {
        let message = ""
        let state = true

        if (name.length === 0) {
            message = "لطفا نام کاربر را مشخص نمایید!"
            state = false
        } else if (lastName.length === 0) {
            message = "لطفا نام خانوادگی کاربر را مشخص نمایید!"
            state = false
        }
            /*else if (userName.length === 0) {
                message = "لطفا نام کاربری را مشخص نمایید!"
                state = false
            }*/
        /*else if ((password.length < 8 || password.length > 72) && isAddNew) {
            message = "رمز عبور باید بین 8 تا 72 کاراکتر باشد!"
            state = false
        }*/
        else if (nationalCode.length < 7) {
            message = "لطفا کد ملی کاربر را به درستی مشخص نمایید!"
            state = false
        }
        /*else if (personalCode.length === 0) {
            message = "لطفا شماره شناسنامه کاربر را مشخص نمایید!"
            state = false
        }*/
        else if (phoneNumber && phoneNumber.length > 0 && phoneNumber.length !== 11) {
            message = "لطفا شماره همراه کاربر را به درستی مشخص نمایید!"
            state = false
        } else if (birthday && birthday.length > 0 && birthday.length !== 10) {
            message = "لطفا تاریخ تولد کاربر را به درستی مشخص نمایید!"
            state = false
        } else if (groupSelectedID === -1) {
            message = "لطفا گروه کاربر را مشخص نمایید!"
            state = false
        } /*else if (address.length <= 0) {
            message = "لطفا آدرس کاربر را مشخص نمایید!"
            state = false
        }*/

        snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, message))
        return state
    }

    useEffect(() => {
        if (!openDialog) {
            clearFields()
        }
    }, [openDialog])

    useEffect(() => {
        if (selectedItemId && parseInt(selectedItemId) >= 0 && openDialog) {
            getUserInfoFromServer()
        }
    }, [selectedItemId, openDialog])

    function getUserInfoFromServer() {
        loading(setLoadingStateDispatch(true))
        service.getUserInfo(
            fundID,
            selectedItemId
        ).then(response => {
            setFieldsData(response)

            loading(setLoadingStateDispatch(false))
        }).catch(reason => {
            ServerErrorHandler(reason, "خطا در دریافت جزئیات کاربر",snackbar,loading)
        })
    }

    function setFieldsData(userData) {
        setName(userData.firstName)
        setLastName(userData.lastName)
        setUserName(userData.username)
        setIsMale(userData.gender)
        setNationalCode(userData.nationalCode)
        setPersonalCode(userData.nBirthCertificate)
        setPhoneNumber(userData.phoneNumber)
        setFixedNumber(userData.tellNumber)
        setBirthday(userData.birthdate ? moment(userData.birthdate, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD') : "")
        setJob(userData.jobTitle)
        setEducation(userData.degreeEducation)
        setAddress(userData.postalAddress)
        setEnabled(userData.enabled)

        setImage(userData.avatarUrl)
        setImageId(userData.avatarId)

        setGroupSelectedID(userData.groupShortInformationPresentationDto.id)
    }

    function doChange() {
        if (checkFieldsConditions(selectedItemId === -1)) {
            needRefresh(true)
            if (selectedItemId === -1) {
                service.addNewUser(
                    fundID,
                    imageFile,
                    name,
                    lastName,
                    userName,
                    password,
                    isMale,
                    nationalCode,
                    personalCode,
                    phoneNumber,
                    fixedNumber,
                    birthday,
                    education,
                    job,
                    groupSelectedID,
                    address,
                    enabled,
                    clearFields
                )
            } else {
                service.changeUserInfo(
                    fundID,
                    selectedItemId,
                    imageFile,
                    imageId,
                    name,
                    lastName,
                    userName,
                    password,
                    isMale,
                    nationalCode,
                    personalCode,
                    phoneNumber,
                    fixedNumber,
                    birthday,
                    education,
                    job,
                    groupSelectedID,
                    address,
                    enabled,
                )
            }
        }
    }

    function clearFields() {
        setName("")
        setLastName("")
        setUserName("")
        setPassword("")
        setPhoneNumber("")
        setNationalCode("")
        setPersonalCode("")
        setFixedNumber("")
        setAddress("")
        setGroupSelectedID(1)
        setJob("")
        setEducation("")
        setBirthday("")
        setIsMale(true)
        setEnabled(true)
        setImage(null)
        setImageId(-1)
        setImageFile(null)
    }

    const [openDialogChangeUsername, setOpenDialogChangeUsername] = useState(false);

    function handleOpenChangeUsernameDialog() {
        setOpenDialogChangeUsername(true)
    }

    function handleCloseChangeUsernameDialog() {
        setOpenDialogChangeUsername(false)
    }

    const [openDialogChangePassword, setOpenDialogChangePassword] = useState(false);

    function handleOpenChangePassword() {
        setOpenDialogChangePassword(true)
    }

    function handleCloseChangePassword() {
        setOpenDialogChangePassword(false)
    }

    function doChangeUsername() {

    }

    function doChangePassword() {

    }

    return (
        <>
            <CashUserChangePassword
                handleClose={handleCloseChangePassword}
                openDialog={openDialogChangePassword}
                selectedItemId={selectedItemId}
            />

            <CashUserChangeUsername
                handleClose={handleCloseChangeUsernameDialog}
                openDialog={openDialogChangeUsername}
                selectedItemId={selectedItemId}
            />

            <Dialog fullScreen onClose={handleClose} aria-labelledby="customized-dialog-title" open={openDialog}
                    id="customized-full-screen-dialog">
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                    <section className="d-flex flex-row flex-nowrap w-100" style={{gap:"16px"}}>

                        <span className="flex-grow-1">{selectedItemId < 0 ? "افزودن عضو جدید" : "مشاهده کاربر"}</span>

                        <button className="btn-confirm" onClick={doChange}>
                            {selectedItemId < 0 ? "افزودن عضو" : "بروزرسانی"}
                        </button>

                        <MoreActionButton inVisibleState={selectedItemId === -1}>
                            <button className="btn-secondary"
                                    onClick={handleOpenChangeUsernameDialog}>
                                تغییر نام کاربری
                            </button>

                            <button className="btn-secondary"
                                    onClick={handleOpenChangePassword}>
                                تغییر رمز عبور
                            </button>
                        </MoreActionButton>

                        <CustomBackButton handleClose={handleClose}/>
                    </section>

                </DialogTitle>
                <section style={{padding: "1rem"}} className="flex-grow-1 p-4">
                    <Box sm={12} className="d-flex alignItemsCenter justifyContentCenter">
                        <input
                            type="file"
                            hidden
                            onChange={onImageChange}
                            id="userAvatar"/>
                        <Avatar
                            src={image}
                            style={{
                                width: '180px',
                                height: '180px',
                                marginTop: '.5rem',
                                alignSelf: 'center',
                                cursor: 'pointer',
                                background: 'linear-gradient(270deg, #0070F3 0%, #4A99F6 100%)'
                            }}
                            onClick={() => document.getElementById("userAvatar").click()}
                        >
                            <AddAPhotoIcon
                                style={{
                                    width: '60px',
                                    height: '60px'
                                }}/>
                        </Avatar>

                    </Box>


                    <Box className="flex-grow-1 w-100" sm={12}>
                        <Grid className='d-flex flex-row flex-wrap flex-grow-1 w-100' sm={12}
                              style={{marginTop: '1rem'}}>
                            <Grid sm={6} md={4} lg={4} xl={4} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" label="نام *"
                                           value={name}
                                           onChange={e => {
                                               setName(e.target.value)
                                           }}/>
                            </Grid>
                            <Grid sm={6} md={4} lg={4} xl={4} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" label="نام خانوادگی *"
                                           value={lastName}
                                           onChange={e => {
                                               setLastName(e.target.value)
                                           }}/>
                            </Grid>
                            <Grid sm={6} md={4} lg={4} xl={4} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" label="نام کاربری"
                                           disabled={selectedItemId >= 0}
                                           value={userName}
                                           onChange={e => {
                                               setUserName(e.target.value)
                                           }}/>
                            </Grid>
                            <Grid sm={6} md={4} lg={4} xl={4} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" label="رمز عبور"
                                           disabled={selectedItemId >= 0}
                                           value={selectedItemId >= 0 ? "********" : password}
                                           placeholder={"بین 8 تا 72  کاراکتر"}
                                           onChange={e => {
                                               setPassword(e.target.value)
                                           }}/>
                            </Grid>
                            <Grid sm={6} md={4} lg={4} xl={4} className='p-2 w-100'>
                                <FormControl variant="outlined" className="w-100">
                                    <InputLabel htmlFor="filled-age-native-simple">جنسیت * </InputLabel>
                                    <Select
                                        value={isMale}
                                        onChange={e => {
                                            setIsMale(e.target.value)
                                        }}
                                        label="وضعیت">
                                        <option className="p-2" value={true}>مرد</option>
                                        <option className="p-2" value={false}>زن</option>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid sm={6} md={4} lg={4} xl={4} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" label="کد ملی *"
                                           value={nationalCode}
                                           onChange={e => {
                                               const value = e.target.value
                                               if (value.length < 11) {
                                                   setNationalCode(value)
                                               }
                                           }}/>
                            </Grid>
                            <Grid sm={6} md={4} lg={4} xl={4} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" label="شماره شناسنامه"
                                           value={personalCode}
                                           onChange={e => {
                                               const value = e.target.value
                                               if (value.length < 11) {
                                                   setPersonalCode(value)
                                               }
                                           }}/>
                            </Grid>
                            <Grid sm={6} md={4} lg={4} xl={4} className='p-2 w-100'>
                                <TextField
                                    className='w-100' variant="outlined" label="شماره همراه"
                                    dir={'ltr'}
                                    placeholder={"0913 123 4567"}
                                    value={convertToMobileNumber(phoneNumber)}
                                    onChange={e => {
                                        if (e.target.value.length < 14)
                                            setPhoneNumber(convertToMobileNumber(e.target.value).replaceAll(" ", ""))
                                    }}/>
                            </Grid>
                            <Grid sm={6} md={4} lg={4} xl={4} className='p-2 w-100'>
                                <TextField
                                    className='w-100'
                                    variant="outlined" label="شماره ثابت"
                                    placeholder={"012 3456 7890"}
                                    dir={'ltr'}
                                    value={convertToHomeNumber(fixedNumber)}
                                    onChange={e => {
                                        setFixedNumber(convertToHomeNumber(e.target.value).replaceAll(" ", ""))
                                    }}/>
                            </Grid>
                            <Grid sm={6} md={4} lg={4} xl={4} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" label="تاریخ تولد"
                                           value={convertToBirthDate(birthday)}
                                           onChange={e => {
                                               setBirthday(convertToBirthDate(e.target.value))
                                           }}/>
                            </Grid>
                            <Grid sm={6} md={4} lg={4} xl={4} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" label="تحصیلات"
                                           value={education}
                                           onChange={e => {
                                               setEducation(e.target.value)
                                           }}/>
                            </Grid>
                            <Grid sm={6} md={4} lg={4} xl={4} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" label="شغل"
                                           value={job}
                                           onChange={e => {
                                               setJob(e.target.value)
                                           }}/>
                            </Grid>
                            <Grid sm={6} md={4} lg={4} xl={4} className='p-2 w-100'>
                                <FormControl variant="outlined" className="w-100">
                                    <InputLabel htmlFor="filled-age-native-simple">گروه *</InputLabel>
                                    <Select
                                        value={groupSelectedID}
                                        onChange={e => {
                                            setGroupSelectedID(e.target.value)
                                        }}
                                        label="وضعیت">
                                        {
                                            groupList.map((item, index) => {
                                                return <option key={index} value={item.id}>{item.name}</option>
                                            })
                                        }
                                    </Select>
                                </FormControl>

                            </Grid>
                            <Grid sm={6} md={8} lg={8} xl={8} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" label="آدرس"
                                           value={address}
                                           onChange={e => {
                                               setAddress(e.target.value)
                                           }}/>
                            </Grid>
                            <Grid sm={12} md={12} lg={12} xl={12} className='p-2 w-100'>
                                <label id='residenceStatus' className="toggle-switch-content">
                                    <span className="toggle-title">فعال/غیرفعال</span>
                                    <label className="switch" htmlFor="MainCategory">
                                        <input
                                            type="checkbox"
                                            id="residenceStatus"
                                            checked={enabled}
                                            onChange={e => {
                                                setEnabled(e.target.checked)
                                            }}
                                        />
                                        <span className="toggle round"/>
                                    </label>

                                </label>
                            </Grid>
                        </Grid>
                    </Box>
                </section>
            </Dialog>
        </>
    )

};

export default CashUsersInfo;
